export default __webpack_public_path__ + "static/treatmentareas_underarmafter-65edf860d71919c43c9eba9c4c45cf13.webp";